import React, { useState, useEffect } from "react";
import {
  useLocation,
  useNavigate,
  useParams
} from "react-router-dom";
import AppRouter from "router/AppRouter";
import MainLoginPage from "./auth/LoginPage.js";
import PasswordResetRequestPage from "./auth/PasswordResetRequestPage.js";
import PasswordResetConfirmPage from "./auth/PasswordResetConfirmPage.js";

// API
import { getDashboard } from "../apps/education-platform/features/dashboard/api/dashboard.api.js";
import { getOrganizationMenu } from "../apps/education-platform/features/dashboard/api/organization.api.js";

const AppBootstrap = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { organization_symbol, organization_branch_symbol } = useParams();
  const branchSymbolInitial = 
    organization_branch_symbol ||
    location.pathname.split("/")[2] || 
    "";

  const orgSymbol = process.env.REACT_APP_ORGANIZATION_SYMBOL;
  const app_stage = process.env.REACT_APP_STAGE;
  const api_url = process.env.REACT_APP_API_URL

  const [state, setState] = useState({
    app_stage: process.env.REACT_APP_STAGE,
    django_media_dir: process.env.REACT_APP_MEDIA_DIR,
    api_url: api_url,

    branch_symbol: branchSymbolInitial,
    organization_symbol: organization_symbol || orgSymbol,

    itemName: branchSymbolInitial || "Dashboard",
    renderView: location.pathname,
    activeHorizontalItem: `/${orgSymbol}/${branchSymbolInitial}`,
    dashboard_data: [],
    organizationmenu_data: [],

    isLoadedDashboard: false,
    isLoadedOrganizationMenu: false,

    error: null,
    apiReady: false,
    isCheckedTheme: true
  });

  /* ===============================
     Helpers
  =============================== */

  const refreshDashboard = async () => {
    try {
      const data = await getDashboard({
        apiUrl: state.api_url,
        organizationSymbol: state.organization_symbol,
        branchSymbol: location.pathname.split("/")[2] || ""
      });

      setState(prev => ({
        ...prev,
        dashboard_data: data,
        isLoadedDashboard: true
      }));
    } catch (err) {
      console.error("Dashboard error:", err);

      setState(prev => ({
        ...prev,
        error: err,
        isLoadedDashboard: false
      }));
    }
  };

  const refreshOrganizationMenu = async () => {
    try {
      const data = await getOrganizationMenu({
        apiUrl: state.api_url,
        organizationSymbol: process.env.REACT_APP_ORGANIZATION_SYMBOL
      });

      const firstOrg = data.organization_menu[0];

      const branchName = state.branch_symbol
        ? firstOrg.organization_branches[state.branch_symbol]
            ?.organization_branch_name
        : firstOrg.organization_branches[
            Object.keys(firstOrg.organization_branches)[0]
          ]?.organization_branch_name;

      setState(prev => ({
        ...prev,
        organizationmenu_data: data,
        isLoadedOrganizationMenu: true,
        itemName: branchName || "Dashboard"
      }));
    } catch (err) {
      console.error("Menu error:", err);

      setState(prev => ({
        ...prev,
        error: err,
        isLoadedOrganizationMenu: false
      }));
    }
  };

  const initializeApp = async () => {
    await refreshDashboard();
    await refreshOrganizationMenu();

    setState(prev => ({
      ...prev,
      apiReady: true
    }));
  };

  /* ===============================
     Lifecycle equivalents
  =============================== */

  // useEffect(() => {
  //   initializeApp();
  // }, [organization_symbol, branchSymbolInitial]);
  useEffect(() => {
    const pathParts = location.pathname.split("/");
    // Platform level dashboard
    if (pathParts.length <= 2 || !pathParts[2]) {
      setState(prev => ({
        ...prev,
        branch_symbol: "",
        itemName: "Dashboard"
      }));
    }

    initializeApp();
  }, [location.pathname]);

  useEffect(() => {
    if (state.apiReady) {
      setState(prev => ({
        ...prev,
        isLoadedDashboard: false,
        branch_symbol: location.pathname.split("/")[2] || "",
        renderView: location.pathname
      }));

      refreshDashboard();
    }
  }, [location.pathname]);

  /* ===============================
     Route guards
  =============================== */

  const isAuthRoute = location.pathname.includes("/auth");

  const isPasswordResetConfirmRoute = location.pathname.includes(
    "/password-reset-confirm"
  );

  const isPasswordResetRoute =
    location.pathname.includes("/password-reset") &&
    !location.pathname.includes("confirm");

  if (isPasswordResetConfirmRoute) {
    return <PasswordResetConfirmPage state={state} />;
  }

  if (isPasswordResetRoute) {
    return <PasswordResetRequestPage state={state} />;
  }

  if (isAuthRoute) {
    return <MainLoginPage state={state} />;
  }

  /* ===============================
     Main Layout
  =============================== */

  return (
    <AppRouter state={state} />
        // <AppShell
        //     state={state}
        //     navigate={navigate}
        // />
    );
};

export default AppBootstrap;